<template>
  <div class="big-dashboard">
  <el-alert v-if="basicData.holidayShowStr" style="flex: 1; padding-right: 20px" :title="basicData.holidayShowStr" type="warning" ></el-alert>
  <div class="dashboard" ref="dashboard">
    <el-row :gutter="40">
      <el-col :span="8">
        <div class="user-info clearfix">
          <div class="user clearfix">
            <div class="avatar" @click="$router.push('/my-center')">
              <img :src="attachUrl ? attachUrl : require('../../assets/img/user-1.png')" />
            </div>
            <div class="info">
              <template v-if="step">{{ isSign ? userData.realName : '未签约' }}</template>
              <span class="number">{{ userData.loginAccount ? userData.loginAccount.mobile : '' }}</span>
            </div>
          </div>
          <div class="integral">
            <span>
              <i>积分</i>
              <b class="number" @click="$refs.integralRecord.init()">{{ gradeInfo.userTotalIntegral || 0 }}</b>
            </span>
          </div>
          <div v-if="warehouseNumber" class="warehouse">
            <span>
              <i @click="copyWarehouse">入仓号<ab-svg name="copy"></ab-svg></i>
              <b class="number">{{ warehouseNumber }}</b>
            </span>
          </div>
          <div v-if="step && isSign" class="center" @click="invoiceClick()">
            <el-badge :value="invoiceState">
              <ab-svg name="user-invoice"></ab-svg>
              <span>发票抬头</span>
            </el-badge>
          </div>
        </div>

        <div class="quick-entry">
          <div class="title">
            <span>快捷入口</span>
          </div>
          <div class="sign-order">
            <div v-if="step && isSign" class="opt" @click="toOrder">
              <b>
                <ab-svg name="order"></ab-svg>
                <span>点击下单</span>
              </b>
              <span>
                <template v-if="todaySubmitBill === 0">您今天还没下单！</template> >>
              </span>
            </div>
            <div v-if="step && !isSign" class="opt" @click="toSign">
              <b>
                <ab-svg name="sign"></ab-svg>
                <span>立即签约</span>
              </b>
              <span>你还尚未与我司签约！ >></span>
            </div>
            <div class="popper"></div>
          </div>
          <div class="entry">
            <!-- <div class="item" @click="invoiceClick">
              <el-badge :value="invoiceState">
                <i><ab-svg name="invoice"></ab-svg></i>
              </el-badge>
              <span>发票抬头</span>
            </div> -->
            <div class="item" @click="orderQuery()">
              <i><ab-svg name="order-query"></ab-svg></i>        
              <span>订单查询</span>
            </div>
            <el-badge :value="todoSum.waitSignSum || ''" class="item">
              <div class="item" @click="toSignature()">
                <i><ab-svg name="order-add"></ab-svg></i>   
                <span>待签章</span>
              </div>
            </el-badge>    
            <div class="item" @click="$router.push('/receive-account')">
              <i><ab-svg name="card"></ab-svg></i>
              <span>收款账号</span>
            </div>
            <div class="item" @click="$router.push('/warehouse-info')">
              <i><ab-svg name="location"></ab-svg></i>
              <span>仓库信息</span>
            </div>
            <!-- <div class="item">
              <i><ab-svg name="guide"></ab-svg></i>
              <span>操作指引</span>
            </div> -->
          </div>
        </div>

        <div class="handy-tool">
          <div class="title">
            <span>便捷工具</span>
          </div>
          <el-tabs
            v-model="toolTabs"
            type="card"
            class="tool-tabs"
            @tab-change="toolTabChange"
          >
            <el-tab-pane label="快递查询" name="express">
              <tool-express ref="toolExpress"></tool-express>
            </el-tab-pane>

            <el-tab-pane label="测算税费" name="taxation">
              <tool-taxation :isSign="isSign" ref="toolTaxation"></tool-taxation>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="exchange-rate">
          <el-tabs
            v-model="rateTabs"
            class="client-tabs"
            @tab-change="allExchangeRate"
          >
            <el-tab-pane label="今日付汇汇率" name="today">
              <div class="detail" @click="$router.push('/exchange-rate-list')">详情>></div>
              <el-row v-loading="loading.exchange">
                <el-col
                  :span="8"
                  v-for="(item, index) in rateData"
                  :key="index"
                >
                  <div class="item clearfix">
                    <div class="flag">
                      <img :src="require(`@/assets/img/dashboard/${item.icon}.png`)" />
                    </div>
                    <div class="name">{{ item.name }}</div>
                    <div class="other">
                      <b class="number">{{ item.value }}</b>
                      <span>
                        <i v-if="item.positive === true" class="up"></i>
                        <i v-else-if="item.positive === false" class="down"></i>
                        {{ item.increase }}
                      </span>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <div class="source">数据来源：中行9:30卖出价格（仅供参考）</div>
            </el-tab-pane>

            <el-tab-pane label="本月海关汇率" name="month">
              <div class="detail" @click="$router.push('/exchange-rate-list')">详情>></div>
              <el-row v-loading="loading.exchange">
                <el-col
                  :span="8"
                  v-for="(item, index) in rateData"
                  :key="index"
                >
                  <div class="item clearfix">
                    <div class="flag">
                      <img :src="require(`@/assets/img/dashboard/${item.icon}.png`)" />
                    </div>
                    <div class="name">{{ item.name }}</div>
                    <div class="other">
                      <b class="number">{{ item.value }}</b>
                      <span>
                        <i v-if="item.positive === true" class="up"></i>
                        <i v-else-if="item.positive === false" class="down"></i>
                        {{ item.increase }}
                      </span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>

      <el-col :span="16">
        <div v-if="step && isSign" class="stats-container">
          <el-tabs
            v-model="statsTabs"
            class="client-tabs single-tabs demo-tabs"
            @tab-change="tabChange"
          >
            <el-tab-pane label="进口统计" v-if="bizType.clientImportRole" name="import"></el-tab-pane>
            <el-tab-pane label="出口统计" v-if="bizType.clientExportRole" name="export"></el-tab-pane>

                <div class="map-wrap">
                    <template v-if="statsTabs == 'import'">
                        <div class="line">
                            <div class="ap-1"></div>
                            <div class="ap-2"></div>
                        </div>
                        <!-- 进口 -->
                        <div class="place">
                            <div v-for="(item, index) in traceData" :key="index" :class="'p-' + item.keyName">
                                <div class="dot"></div>
                                <el-popover placement="right-end" :width="480" popper-class="stats-progress-pop" trigger="hover">
                                    <template #reference>
                                        <div class="pop">
                                        <i></i>
                                        <span>{{ item.title }}<b class="number">{{ item.sum }}</b>单</span>
                                        </div>
                                    </template>
                                    <stats-progress
                                        v-if="!!item.list.length"
                                        :keyName="item.keyName"
                                        :sum="item.sum"
                                        :list="item.list"
                                        @updateSum="(value) => item.sum = value"
                                    ></stats-progress>
                                </el-popover>
                            </div>
                        </div>
                    </template>

                    <template v-else-if="statsTabs == 'export'">
                        <div class="lineEx">
                            <div class="ap-3"></div>
                        </div>
                        <!-- 出口 -->
                        <div class="p-exit">
                            <div v-for="(item, index) in exitTraceData" :key="index" :class="'p-' + item.keyName">
                                <div class="dot"></div>
                                    <el-popover
                                        placement="right-end"
                                        :width="480"
                                        popper-class="stats-progress-pop"
                                        trigger="hover"
                                    >
                                    <template #reference>
                                        <div class="pop">
                                            <i></i>
                                            <span>{{ item.title }}<b class="number">{{ item.sum }}</b>单</span>
                                        </div>
                                    </template>
                                    <stats-progress
                                        v-if="!!item.list.length"
                                        :keyName="item.keyName"
                                        :sum="item.sum"
                                        :list="item.list"
                                        type="exit"
                                        @updateSum="(value) => item.sum = value"
                                    ></stats-progress>
                                </el-popover>
                            </div>
                        </div>
                    </template>


                    <div v-if="statsTabs == 'export'? exitShowTodo : showTodo" class="todo-wrap clearfix">
                    <div class="my-todo">
                        <div class="title">我的待办</div>
                        <div class="chart" id="myChart"></div>
                    </div>
                    <div class="yx-todo">
                        <div class="title">一咻待办</div>
                        <div class="chart" id="yxChart"></div>
                    </div>
                    </div>

                    <div class="map"><img src="@/assets/img/dashboard/map.png"></div>
                </div>
            

            <!-- <el-tab-pane label="仓储统计" name="storage"></el-tab-pane> -->
          </el-tabs>
        </div>

        <div v-if="step && !isSign" class="video-container">
          <div class="title">视频介绍</div>
          <div class="video">
            <video src="https://static.z-easy.com.cn/static/video.mp4" width="100%" height="100%" autoplay controls></video>
          </div>
        </div>
      </el-col>
    </el-row>

    <integral-record :totalIntegral="gradeInfo.userTotalIntegral" ref="integralRecord" @exchange="getPrincipalGradeInfo"></integral-record>

    <invoice-header @confirm="getClientWorkBench" ref="invoiceHeader"></invoice-header>

    <textarea class="copy-text" id="copyText"></textarea>
  </div>
  </div>
</template>

<script>
import integralRecord from '../personal-center/integral-record.vue'
import invoiceHeader from '../workbench/invoice-header.vue'
import toolExpress from '../workbench/tool-express.vue'
import toolTaxation from '../workbench/tool-taxation.vue'
import statsProgress from '../workbench/stats-progress.vue'
import * as echarts from 'echarts'

export default {
  components: {
    integralRecord,
    invoiceHeader,
    toolExpress,
    toolTaxation,
    statsProgress
  },

  data() {
    return {
      loading: {
        exchange: false
      },
      basicData: {
        principal: {},
        principalExtend: {}
      },
      userData: {},
      attachUrl: '',
      gradeInfo: {},
      warehouseNumber: '',
      todaySubmitBill: '',
      bizType: {},  //进出口状态
      rateData: {
        usd: {
          name: '美元',
          icon: 'usa'
        },
        eur: {
          name: '欧元',
          icon: 'euro'
        },
        hkd: {
          name: '港币',
          icon: 'hongkong'
        },
        gbp: {
          name: '英镑',
          icon: 'pound'
        },
        sgd: {
          name: '新加坡元',
          icon: 'singapore'
        },
        jpy: {
          name: '日元',
          icon: 'yen'
        }
      },
      toolTabs: 'express',
      rateTabs: 'today',
      statsTabs: 'import',
      //进口
      traceData: [
        {
          title: '境外供应商',
          keyName: '1',
          sum: 0,
          list: []
        },
        {
          title: '到香港',
          keyName: '2',
          sum: 0,
          list: []
        },
        {
          title: '已通关',
          keyName: '3',
          sum: 0,
          list: []
        },
        {
          title: '派送中',
          keyName: '4',
          sum: 0,
          list: []
        },
        {
          title: '已完成',
          keyName: '5',
          sum: 0,
          list: []
        },
        {
          title: '到国内机场/码头等',
          keyName: '6',
          sum: 0,
          list: []
        }
      ],
        //出口
        exitTraceData: [
            {
                title: '供应商',
                keyName: '1',
                sum: 0,
                list: []
            },
            {
                title: '已通关',
                keyName: '3',
                sum: 0,
                list: []
            },
            {
                title: '境外客户',
                keyName: '5',
                sum: 0,
                list: []
            },
        ],
      todoSum: {},
      exitTodoSum: {},
      myChart: null,
      yxChart: null,
      myOption: {
        series: [
          {
            name: 'my todo',
            type: 'pie',
            top: '20%',
            bottom: '10%',
            radius: ['30%', '80%'],
            minShowLabelAngle: 1,
            startAngle: 45,
            label: {
              formatter: '{b|{b}}\n{c|{c}}',
              rich: {
                b: {
                  fontSize: 14,
                  lineHeight: 20
                },
                c: {
                  fontSize: 22,
                  color: '#0a7bfd',
                  fontFamily: 'DIN_Condensed_Bold'
                }
              }
            },
            data: [],
            // cursor: 'default' // 鼠标样式
          }
        ]
      },
      yxOption: {
        series: [
          {
            name: 'yx todo',
            type: 'pie',
            top: '20%',
            bottom: '10%',
            radius: ['30%', '80%'],
            minShowLabelAngle: 1,
            startAngle: 45,
            label: {
              formatter: '{b|{b}}\n{c|{c}}',
              rich: {
                b: {
                  fontSize: 14,
                  lineHeight: 20
                },
                c: {
                  fontSize: 22,
                  color: '#0a7bfd',
                  fontFamily: 'DIN_Condensed_Bold'
                }
              }
            },
            data: [],
            // cursor: 'default' // 鼠标样式
          }
        ]
      }
    }
  },

  computed: {
    step() {
      return this.$store.state.step
    },

    isSign() {
      if (this.step === '99') { // 已签约
        // 入仓号
        this.getWarehouseNumber()
        // 待办统计
        // this.getTodoSum()
        // 订单list
        this.getListAircraftTrace()
        return true
      }
      return false
    },
    /* bizType() {
      return this.$utils.getSessionStorage('bizType')
    }, */
    invoiceState() {
      //改电子发票隐藏发票状态
      // if (this.basicData && this.basicData.principalExtend && !!Object.keys(this.basicData.principalExtend).length) {
      //   let fields = ['billAddress', 'billTel', 'billBankName', 'billBankAcct', 'receiptInvoiceAddress', 'receiptInvoicePerson', 'receiptInvoiceTel']
      //   let field = ''
      //   for (let i in fields) {
      //     field = fields[i]
      //     if (!this.basicData.principalExtend[field]) {
      //       return '待完善'
      //     }
      //   }
      // }
      // return ''
    },

    showTodo() {
      if (this.todoSum.completeSum || this.todoSum.waitPayFeeCount || this.todoSum.waitPayExchangeCount || this.todoSum.waitInRepositorySum || this.todoSum.waitDrawInvoiceSum || this.todoSum.waitClearancedSum) {
        return true
      }
      return false
    },
    
    exitShowTodo(){
        if (this.exitTodoSum.waitPayFeeCount || this.exitTodoSum.waitPayExchangeCount || this.exitTodoSum.waitTaxRebate || this.exitTodoSum.waitDrawInvoiceSum || this.exitTodoSum.waitClearancedSum) {
            return true
        }
        return false
    }
  },

  created() {
    // 获取公司信息
    this.getClientWorkBench()
    // 用户信息
    this.getByUserCenter()
    // 获取头像url
    this.getAttachUrl()
    // 会员等级信息
    this.getPrincipalGradeInfo()
    // 今日下单数
    this.getTodaySubmitBill()
    // 汇率
    this.allExchangeRate()
    //进出口权限
    this.getUserInfo()
  },

  mounted() {
    this.setChartSize()
    window.addEventListener('resize', this.setChartSize);
  },

  methods: {
    getUserInfo() {
        this.$get("/oms/businessWorkbench/getUserInfo").then(({data}) => {
            if(data && data.code === 'C0000') {
                this.bizType.clientImportRole = data.result.clientImportRole
                this.bizType.clientExportRole = data.result.clientExportRole
                this.bizType.clientSalesRole = data.result.clientSalesRole
                this.bizType.clientWmsRole = data.result.clientWmsRole
                if(!this.bizType.clientImportRole) {
                    this.statsTabs = 'export'
                    this.$nextTick(()=>{
                        this.tabChange('export')
                    })
                }else{
                    this.statsTabs = 'import'
                    this.$nextTick(()=>{
                        this.tabChange('import')
                    })
                }
            }
        })
    },

    // 获取公司信息
    getClientWorkBench() {
      this.$post('/bas/client/basCustomer/getClientWorkBench').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.basicData = data.result || {}
        }
      })
    },

    // 用户信息
    getByUserCenter() {
      this.$get('/p/user/getByUserCenter').then(({ data }) => {
        if (data.code === 'C0000') {
          this.userData = data.result
        }
      })
    },

    // 获取头像url
    getAttachUrl() {
      this.$post('/p/user/getAttachUrlById').then(({ data }) => {
        if(data.code === 'C0000') {
          this.attachUrl = data.message
        }
      })
    },

    // 会员等级信息
    getPrincipalGradeInfo() {
      this.$get('/bas/client/vipInfo/getPrincipalGradeInfo').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.gradeInfo = data.result
        }
      })
    },

    // 入仓号
    getWarehouseNumber() {
      this.$post('/bas/client/basCustomer/getClientWorkBench').then(({ data }) => {
        if (data.code === 'C0000' && data.result) {
          this.warehouseNumber = data.result.principal.number
        }
      })
    },

    // 复制仓库信息
    copyWarehouse() {
      let infoText = '錦盛（香港）有限公司\n' +
      'Future Promising Company Limited\n' +
      '地址：香港沙田安平街 8 号偉達中心 8 楼 801 室\n' +
      'Units 801, Grandtech Centre, No.8 OnPing Street, Siu Lek Yuen, Shatin, NewTerritories, Hong Kong\n' +
      '邮箱：luo.zhanwei@cicsc.com\n' +
      '联系人：羅占偉\n' +
      '電話：00852-26089369\n' +
      '传真：00852-26089331\n' +
      '入仓号：' + this.warehouseNumber
      const input = document.getElementById('copyText')  // 找到虚拟的输入框
      input.value = infoText // 修改文本框的内容
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$message({
        type: 'success',
        message: '复制成功!',
        offset: 380,
        grouping: true
      })
    },

    // 立即下单
    toOrder() {
      if (this.isSign) {
        let userInfo = this.$utils.getSessionStorage('userInfo') || {}
        let url = ''
        //优先跳转进口订单。
        if (userInfo.clientExportRole) {
          url = '/export-orders-detail'
        }
        if (userInfo.clientImportRole) {
          url = '/import-orders-detail'
        }
        if (!url) {
          this.$message({
            type: 'error',
            message: '业务类型不存在！',
            offset: 380,
            grouping: true
          })
          return false
        }
        this.$router.push({
          path: url,
          query: { status: 'add', cache: false }
        })
      } else {
        this.signTips('您尚未与我司签约，无法使用该功能，是否马上签约？')
      }
    },
    // 我的签章
    toSignature() {
      if (this.isSign) {
        this.$router.push(
          {
            path: '/my-signature',
            query: {
              activedName: 'wait'
            }
          }
        )
      } else {
        this.signTips('您尚未与我司签约，无法使用该功能，是否马上签约？')
      }
    },
    // 订单查询
    orderQuery() {
      if (this.isSign) {
        this.$router.push({
          path: '/import-orders-list'
        })
      } else {
        this.signTips('您尚未与我司签约，无法使用该功能，是否马上签约？')
      }
    },

    // 签约提示
    signTips(content) {
      this.$confirm(content, '温馨提示', {
        confirmButtonText: '立即签约',
        cancelButtonText: '暂不签约'
      }).then(() => {
        this.toSign()
      }).catch(() => {})
    },

    // 去签约
    toSign() {
      this.$router.push('/sign-contract')
    },

    // 今日下单数
    getTodaySubmitBill() {
      this.$get('/oms/client/workbench/getTodaySubmitBill').then(({ data }) => {
        if (data.code === 'C0000') {
          this.todaySubmitBill = data.result
        }
      })
    },

    // 发票抬头
    invoiceClick() {
      if (this.isSign) {
        this.$refs.invoiceHeader.init(this.basicData && this.basicData.principalExtend ? this.basicData.principalExtend : {})
      } else {
        this.signTips('您尚未与我签约，无法获取贵公司的发票抬头信息，是否马上去签约？')
      }
    },

    // 便捷工具
    toolTabChange(value) {
      this.$refs.toolExpress.close()
      this.$refs.toolTaxation.close()
    },

    // 汇率
    allExchangeRate() {
      this.$post('/cms/customsWorkbench/allExchangeRate', {}, this.loading, 'exchange').then(({ data }) => {
        if (data && data.code === 'C0000') {
          data.result.forEach(row => {
            const keyName = row.sourceCurrency.toLowerCase()
            if (this.rateTabs === 'month') {
              this.rateData[keyName].value = row.customsRate
              this.rateData[keyName].positive = row.customsRatePositive
              this.rateData[keyName].increase = row.customsRateIncrease
            } else {
              this.rateData[keyName].value = row.spotSellingPriceNine
              this.rateData[keyName].positive = row.spotSellingPriceNinePositive
              this.rateData[keyName].increase = row.spotSellingPriceNineIncrease
            }
          })
        }
      })
    },

    // 待办统计
    getTodoSum() {
      this.$post('/oms/client/workbench/todoSum').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.todoSum = data.result
          this.myOption.series[0].data = [
            {
              value: this.todoSum.unFinishedSum || 0,
              name: '待收货',
              itemStyle: {
                color: '#ff8400'
              }
            },
            {
              value: this.todoSum.waitPayFeeCount || 0,
              name: '待付费',
              itemStyle: {
                color: '#e21010'
              }
            },
            // {
            //   value: this.todoSum.waitSignSum,
            //   name: '待签章',
            //   itemStyle: {
            //     color: '#13227a'
            //   }
            // },
            {
              value: this.todoSum.waitPayExchangeCount || 0,
              name: '待付汇',
              itemStyle: {
                color: '#0b7cff'
              }
            }
          ]
          this.yxOption.series[0].data = [
            {
              value: this.todoSum.waitInRepositorySum || 0,
              name: '待到仓',
              itemStyle: {
                color: '#ff8400'
              }
            },
            {
              value: this.todoSum.waitDrawInvoiceSum || 0,
              name: '待开票',
              itemStyle: {
                color: '#13227a'
              }
            },
            {
              value: this.todoSum.waitClearancedSum || 0,
              name: '待报关',
              itemStyle: { 
                color: '#0b7cff'
              }
            }
          ]
          setTimeout(() => {
            if (this.showTodo) {
              // 我的待办
              this.myChart = echarts.init(document.getElementById('myChart'))
              this.myChart.setOption(this.myOption)
              // 一咻待办
              this.yxChart = echarts.init(document.getElementById('yxChart'))
              this.yxChart.setOption(this.yxOption)
              this.myChart.on('click', params => {
                if(params.data && params.data.name) {
                  let activeNameObj = {
                    "待付汇": '41',
                    "待收货": "all",
                    "待付费": "43",
                    // "待签章": "wait"
                  }
                  let path = '/import-orders-list'
                  // if(params.data.name == '待签章') {
                  //   path = '/my-signature'
                  // } 

                    this.$store.commit("activeIndex", '01')
                    this.$store.commit("nowBizType", '01')
                    let bizType = this.$utils.getSessionStorage('bizType')
                    bizType.activeIndex = '01'
                    this.$utils.setSessionStorage('bizType', bizType)
                    this.$emit('childClick')

                  this.$router.push(
                    {
                      path,
                      query: {
                        activedName: activeNameObj[params.data.name]
                      }
                    }
                  )
                }
              })
              this.yxChart.on('click', params => {
                if(params.data && params.data.name) {
                  let activeNameObj = {
                    "待到仓": 'warehouse',
                    "待报关": "declare",
                    "待开票": "home",
                  }
                  let path = '/import-orders-list'
                  if(params.data.name == '待开票') {
                    path = '/invoice-list'
                  }

                    this.$store.commit("activeIndex", '01')
                    let bizType = this.$utils.getSessionStorage('bizType')
                    bizType.activeIndex = '01'
                    this.$utils.setSessionStorage('bizType', bizType)
                    this.$emit('childClick')

                  this.$router.push(
                    {
                      path,
                      query: {
                        activedName: activeNameObj[params.data.name]
                      }
                    }
                  )
                }
              })
            }
          }, 500)
        }
      })
    },

    // 进口订单list
    getListAircraftTrace() {
      this.$post('/oms/client/workbench/listAircraftTrace', {
        data: {
          queryType: null
        },
        pageNum: 1,
        pageSize: 10
      }).then(({ data }) => {
        if (data && data.code === 'C0000' && data.result) {
          this.traceData.forEach(row => {
            const keyName = row.keyName
            row.sum = data.result.groupSum[keyName]
            row.list = data.result.groupData[keyName].list || []
          })
        }
      })
    },
    //出口订单List
    getListExitAircraftTrace(){
        this.$post('/oms/client/workbench/listAircraftTraceEx', {
            data: {
                queryType: undefined
            },
            pageNum: 1,
            pageSize: 10
        }).then(({ data }) => {
            if (data && data.code === 'C0000' && data.result) {
                this.exitTraceData.forEach(row => {
                    const keyName = row.keyName
                    row.sum = data.result.groupSum[keyName]
                    row.list = data.result.groupData[keyName].list || []
                })
            }
        })
    },
    //出口待办统计
    exitGetTodoSum(){
        this.$post('/oms/client/workbench/todoSumEx').then(({ data }) => {
            if (data && data.code === 'C0000') {
                this.exitTodoSum = data.result
                this.myOption.series[0].data = [
                    {
                        value: this.exitTodoSum.waitPayFeeCount || 0,
                        name: '待付费',
                        itemStyle: {
                            color: '#e21010'
                        }
                    },
                    {
                        value: this.exitTodoSum.waitPayExchangeCount || 0,
                        name: '待结汇',
                        itemStyle: {
                            color: '#0b7cff'
                        }
                    }
                ]
                this.yxOption.series[0].data = [
                    {
                        value: this.exitTodoSum.waitTaxRebate || 0,
                        name: '待出证',
                        itemStyle: {
                            color: '#ff8400'
                        }
                    },
                    {
                        value: this.exitTodoSum.waitDrawInvoiceSum || 0,
                        name: '待开票',
                        itemStyle: {
                            color: '#13227a'
                        }
                    },
                    {
                        value: this.exitTodoSum.waitClearancedSum || 0,
                        name: '待报关',
                        itemStyle: { 
                            color: '#0b7cff'
                        }
                    }
                ]
                setTimeout(() => {
                    if (this.exitShowTodo) {
                    // 我的待办
                    this.myChart = echarts.init(document.getElementById('myChart'))
                    this.myChart.setOption(this.myOption)
                    // 一咻待办
                    this.yxChart = echarts.init(document.getElementById('yxChart'))
                    this.yxChart.setOption(this.yxOption)
                    this.myChart.on('click', params => {
                        if(params.data && params.data.name) {
                            let activeNameObj = {
                                "待结汇": '41',
                                "待收货": "all",
                                "待付费": "43",
                            }
                            let path = '/export-orders-list'

                            this.$store.commit("activeIndex", '02')
                            this.$store.commit("nowBizType", '02')
                            let bizType = this.$utils.getSessionStorage('bizType')
                            bizType.activeIndex = '02'
                            this.$utils.setSessionStorage('bizType', bizType)
                            this.$emit('childClick')

                            this.$router.push(  
                                {
                                    path,
                                    query: {
                                        activedName: activeNameObj[params.data.name]
                                    }
                                }
                            )
                        }
                    })
                    this.yxChart.on('click', params => {
                        if(params.data && params.data.name) {
                            let activeNameObj = {
                                "待出证": 'warehouse',
                                "待报关": "declare",
                                "待开票": "home",
                            }
                            let path = '/export-orders-list'
                            if(params.data.name == '待开票') {
                                path = '/invoice-list'
                            }
                            if(params.data.name == '待出证') {
                                path = '/export-certificate-list'
                            }

                            this.$store.commit("activeIndex", '02')
                            let bizType = this.$utils.getSessionStorage('bizType')
                            bizType.activeIndex = '02'
                            this.$utils.setSessionStorage('bizType', bizType)
                            this.$emit('childClick')

                            this.$router.push(
                                {
                                    path,
                                    query: {
                                        activedName: activeNameObj[params.data.name]
                                    }
                                }
                            )
                        }
                    })
                    }
                }, 50)
            }
        })
    },

    setChartSize() {
      if (this.showTodo || this.exitShowTodo) {
        this.myChart && this.myChart.resize()
        this.yxChart && this.yxChart.resize()
      }
    },
    tabChange(val){
        if(this.myChart && this.yxChart){
            this.myChart.off("click")
            this.yxChart.off("click")
        }
        switch (val) {
            case 'import':
                this.getTodoSum()
            break;
            case 'export':
                this.getListExitAircraftTrace()
                this.exitGetTodoSum()
            break;
        }
    }
  }
}
</script>

<style lang="scss">
@keyframes airplane1 {
  0% {
    top: 0;
    right: 0;
    transform: rotate(-30deg);
    opacity: 0;
  }
  20% {
    top: 14.25%;
    right: 5%;
    transform: rotate(-18deg);
    opacity: 0.5;
  }
  40% {
    top: 31.25%;
    right: 15%;
    transform: rotate(-8deg);
    opacity: 1;

  }
  60% {
    top: 50.45%;
    right: 30%;
    transform: rotate(2deg);
    opacity: 1;
  }
  80% {
    top: 66.65%;
    right: 50%;
    transform: rotate(12deg);
    opacity: 1;
  }
  100% {
    top: 75.4%;
    right: 68%;
    transform: rotate(22deg);
    opacity: 0.5;
  }
}

@keyframes airplane2 {
  0% {
    top: 2.5%;
    right: 0;
    transform: rotate(-40deg);
    opacity: 0;
  }
  20% {
    top: 16.25%;
    right: 5%;
    transform: rotate(-38deg);
    opacity: 0.5;
  }
  40% {
    top: 38.4%;
    right: 15%;
    transform: rotate(-30deg);
    opacity: 1;

  }
  60% {
    top: 64.2%;
    right: 30%;
    transform: rotate(-20deg);
    opacity: 1;
  }
  80% {
    top: 86.2%;
    right: 50%;
    transform: rotate(0deg);
    opacity: 1;
  }
  100% {
    top: 94.8%;
    right: 82%;
    transform: rotate(25deg);
    opacity: 0.5;
  }
}

@keyframes airplane3 {
    0% {
        top: 79%;
        right: 82%;
        transform: rotate(210deg);
        opacity: 0;
    }
    20% {
        top: 76%;
        right: 64%;
        transform: rotate(200deg);
        opacity: 1;
    }
    40% {
        top: 62.5%;
        right: 42%;
        transform: rotate(189deg);
        opacity: 1;
    }
    60% {
        top: 46.25%;
        right: 24%;
        transform: rotate(178deg);
        opacity: 1;
    }
    80% {
        top: 25%;
        right: 9%;
        transform: rotate(167deg);
        opacity: 1;
    }
    100% {
        top: 3%;
        right: -1%;
        transform: rotate(158deg);
        opacity: 0.5;
    }
}
@keyframes airplane4 {
    0% {
        top: 95%;
        right: 82%;
        transform: rotate(200deg);
        opacity: 0;
    }
    18% {
        top: 90.2%;
        right: 58%;
        transform: rotate(188deg);
        opacity: 1;
    }
    30%{
        top: 82.2%;
        right: 44%;
        transform: rotate(171deg);
        opacity: 1;
    }
    44% {
        top: 65.2%;
        right: 30%;
        transform: rotate(164deg);
        opacity: 1;
    }
    68% {
        top: 38.4%;
        right: 14.4%;
        transform: rotate(154deg);
        opacity: 1;
    }
    85% {
        top: 16.25%;
        right: 4.5%;
        transform: rotate(147deg);
        opacity: 1;
    }
    100% {
        top: 2.5%;
        right: -0.8%;
        transform: rotate(143deg);
        opacity: 0.5;
    }
}
@keyframes bounceIn {
  0%,20%,40%,60%,80%,to {
    -webkit-animation-timing-function: cubic-bezier(.215,.61,.355,1);
    animation-timing-function: cubic-bezier(.215,.61,.355,1)
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(.3,.3,.3);
    transform: scale3d(.3,.3,.3)
  }

  20% {
    -webkit-transform: scale3d(1.1,1.1,1.1);
    transform: scale3d(1.1,1.1,1.1)
  }

  40% {
    -webkit-transform: scale3d(.9,.9,.9);
    transform: scale3d(.9,.9,.9)
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03,1.03,1.03);
    transform: scale3d(1.03,1.03,1.03)
  }

  80% {
    -webkit-transform: scale3d(.97,.97,.97);
    transform: scale3d(.97,.97,.97)
  }

  to {
    opacity: 1;
    -webkit-transform: scaleX(1);
    transform: scaleX(1)
  }
}
.big-dashboard{
  width: 100%;
  .demo-tabs{
        /*去掉切换时el-tab-pane底部的蓝色下划线*/
        .el-tabs__active-bar {
            background-color: transparent !important;
        }
        /*去掉tabs底部的下划线*/
        .el-tabs__nav-wrap::after {
            position: static !important;
        }
        .el-tabs__item.is-top {
            padding: 0;
            margin-right: 40px;
            font-size: 16px;
            height: 40px;
            &.is-active {
                background-image: url(@/assets/img/nav-active.png);
                background-repeat: no-repeat;
                background-position: bottom;
                border-bottom: none;
                font-size: 18px;
            }
        }

        .el-tabs__content {
            margin-top: 20px;
        }
    }
}
.dashboard {
  width: 100%;
  padding: 20px;
  border-radius: 8px;
  font-size: 14px;
  text-align: left;
  color: #000;
  background: #fff;
  .user-info {
    position: relative;
    width: 100%;
    height: 1rem;
    padding: 0.18rem;
    border-radius: 0.16rem;
    // overflow: hidden;
    background: linear-gradient(#f1f4f8, #d8e7f9);
    .user {
      float: left;
      width: 50%;
      height: 100%;
      .avatar {
        float: left;
        width: 0.67rem;
        height: 0.67rem;
        padding: 2px;
        margin-right: 0.18rem;
        border-radius: 50%;
        overflow: hidden;
        background: #fff;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .info {
        float: left;
        line-height: 0.3rem;
        span {
          display: block;
          font-size: 20px;
        }
      }
    }
    .integral, .warehouse {
      position: relative;
      float: left;
      width: 17%;
      padding-left: 0.18rem;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 13%;
        z-index: 2;
        width: 2px;
        height: 74%;
        background: #dedede;
      }
      span {
        line-height: 0.3rem;
        vertical-align: top;
        i {
          display: block;
          font-style: normal;
        }
        b {
          font-size: 20px;
          font-weight: normal;
          color: #0B7CFF;
          cursor: pointer;
        }
      }
    }
    .warehouse {
      width: 33%;
      &::before {
        display: none;
      }
      span {
        i {
          cursor: pointer;
          .icon-svg {
            width: 14px;
            height: 14px;
            margin: 2px 0 0 5px;
            vertical-align: text-top;
          }
        }
        b {
          color: #f37041;
          cursor: auto;
        }
      }
    }
    .center {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
      width: 0.96rem;
      height: 0.34rem;
      line-height: 0.34rem;
      background: linear-gradient(34deg, #0A7CFF, #3E98FF);
      border-bottom-left-radius: 0.16rem;
      border-top-right-radius: 0.16rem;
      font-size: 0.14rem;
      text-align: center;
      color: #fff;
      cursor: pointer;
      .icon-svg {
        width: 0.14rem;
        height: 0.16rem;
        margin: 2px 0.04rem 0 0;
        vertical-align: text-top;
      }
      span {
        vertical-align: top;
      }
    }
  }
  .quick-entry {
    margin-top: 0.37rem;
    .title {
      height: 0.2rem;
      line-height: 0.2rem;
      span {
        font-size: 18px;
        vertical-align: top;
      }
    }
    .sign-order {
      margin-top: 0.38rem;
      .opt {
        display: flex;
        justify-content: space-between;
        height: 0.5rem;
        padding: 0 0.2rem;
        border-radius: 0.08rem;
        line-height: 0.5rem;
        color: #fff;
        background: linear-gradient(34deg, #0A7CFF, #3E98FF);
        cursor: pointer;
        b {
          .icon-svg {
            width: 0.24rem;
            height: 0.24rem;
            margin: 0.12rem 0.15rem 0 0;
            vertical-align: top;
          }
          span {
            font-size: 16px;
            font-weight: normal;
            vertical-align: top;
          }
        }
        > span {
          font-size: 16px;
        }
      }
    }
    .entry {
      display: flex;
      justify-content: space-around;
      margin-top: 0.3rem;
      .item {
        text-align: center;
        cursor: pointer;
        i {
          display: block;
          width: 0.64rem;
          height: 0.64rem;
          margin-bottom: 0.12rem;
          line-height: 0.64rem;
          border-radius: 8px;
          background: #f2f7ff;
          .icon-svg {
            width: 0.36rem;
            height: 0.36rem;
            margin-top: 0.14rem;
            vertical-align: top;
          }
        }
        span {
          display: block;
          line-height: 100%;
        }
      }
    }
  }
  .handy-tool {
    margin-top: 0.37rem;
    .title {
      height: 0.2rem;
      line-height: 0.2rem;
      span {
        font-size: 18px;
        vertical-align: top;
      }
    }
    .tool-tabs {
      margin-top: 0.28rem;
      .el-tabs__header {
        height: 0.34rem;
        margin-bottom: 0;
        border: none;
        .el-tabs__nav {
          border: none;
          border-radius: 0;
        }
        .el-tabs__item {
          height: 0.34rem;
          line-height: 0.34rem;
          border-top-left-radius: 0.08rem;
          border-top-right-radius: 0.08rem;
          border: 1px solid #f2f7ff;
          border-bottom: none;
          background: #f2f7ff;
          vertical-align: top;
          &.is-active {
            border-color: #E5E5E5;
            background: #fff;
          }
        }
      }
      .el-tabs__content {
        overflow: visible;
      }
    }
  }
  .exchange-rate {
    margin-top: 0.33rem;
    .client-tabs {
      .el-tabs__header {
        margin-bottom: 0.25rem;
      }
      .el-tabs__content {
        overflow: visible;
        .detail {
          position: absolute;
          top: -52px;
          right: 0;
          cursor: pointer;
        }
        .el-col {
          &:nth-child(-n+3) {
            margin-bottom: 0.36rem;
          }
        }
        .item {
          line-height: 0.2rem;
          .flag {
            float: left;
            width: 0.5rem;
            height: 0.4rem;
            margin-right: 0.1rem;
            border-radius: 0.04rem;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              vertical-align: top;
            }
          }
          .name {
            float: left;
            width: calc(100% - 0.62rem);
          }
          .other {
            float: left;
            width: calc(100% - 0.62rem);
            > * {
              vertical-align: top;
            }
            b {
              margin-right: 0.1rem;
            }
            span {
              display: inline-block;
              font-size: 12px;
              i {
                display: inline-block;
                width: 10px;
                height: 9px;
                margin-right: 2px;
                background-repeat: no-repeat;
                background-size: contain;
                &.up {
                  background-image: url(@/assets/img/dashboard/rate-up.svg);
                }
                &.down {
                  background-image: url(@/assets/img/dashboard/rate-down.svg);
                }
              }
            }
          }
        }
        .source {
          margin-top: 0.24rem;
          color: #7f7f7f;
        }
      }
    }
  }

  .video-container {
    width: 100%;
    .title {
      font-size: 18px;
    }
    .video {
      width: 100%;
      margin-top: 0.30rem;
      border-radius: 0.16rem;
      overflow: hidden;
      video {
        width: 100%;
        height: 100%;
      }
    }
  }

  .stats-container {
    width: 100%;
    /* .single-tabs {
      .el-tabs__item.is-active {
        color: #000;
        &::after {
          display: none;
        }
      }
    } */
    .map-wrap {
      position: relative;
      width: 100%;
      font-size: 14px;
      .map {
        position: relative;
        z-index: 1;
        width: 100%;
        height: 100%;
        font-size: 0;
        img {
          width: 100%;
          height: auto;
          border-radius: 15px;
        }
      }
      .line {
        position: absolute;
        right: 0;
        top: 2.45%;
        z-index: 2;
        width: 59.78%;
        height: 51.02%;
        background: url(@/assets/img/dashboard/line.png) no-repeat;
        background-size: contain;
        .ap-1 {
          position: absolute;
          width: 5.76%;
          height: 9.87%;
          background: url(@/assets/img/dashboard/ap-1.png) no-repeat;
          background-size: contain;
          animation: airplane1 4s linear infinite;
        }
        .ap-2 {
            position: absolute;
            width: 6.04%;
            height: 10.4%;
            background: url(@/assets/img/dashboard/ap-2.png) no-repeat;
            background-size: contain;
            animation: airplane2 4s linear infinite;
        }

      }
      .lineEx{
        position: absolute;
        right: 0;
        top: 2.45%;
        z-index: 2;
        width: 59.78%;
        height: 51.02%;
        background: url(@/assets/img/dashboard/line-ex.png) no-repeat;
        background-size: contain;
        .ap-3 {
            position: absolute;
            width: 6.04%;
            height: 10.4%;
            background: url(@/assets/img/dashboard/ap-2.png) no-repeat;
            background-size: contain;
            transform: rotate(205deg);
            animation: airplane4 4s linear infinite;
        }
      }
      .place {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        width: 100%;
        height: 100%;
        overflow: hidden;
        color: #fff;
        > div {
          .dot {
            position: absolute;
            width: 1.679261%;
            height: 2.721088%;
            border: 3px solid #0a7bfd;
            border-radius: 50%;
            background: #fff;
          }
          .pop {
            position: absolute;
            height: 40px;
            padding: 2px;
            border-radius: 20px;
            background-color: #0a7bfd;
            cursor: pointer;
            animation: bounceIn 0.75s ease 0.5s;
            i {
              display: inline-block;
              width: 36px;
              height: 36px;
              border-radius: 50%;
              background-color: #fff;
              background-repeat: no-repeat;
              background-position: center;
            }
            span {
              display: inline-block;
              padding: 0 10px 0 4px;
              line-height: 34px;
              vertical-align: top;
              b {
                padding: 0 4px;
                font-size: 22px;
                font-weight: 500;
              }
            }
          }
        }
        .p-1 {
          .dot {
            top: 8.75%;
            left: 95.97%;
            border-color: #0ab0a6;
          }
          .pop {
            top: 11.56%;
            right: 3.11%;
            border-top-right-radius: 0;
            background-color: #0ab0a6;
            i {
              background-image: url(@/assets/img/dashboard/dot-icon-1.png);
            }
          }
        }
        .p-2 {
          .dot {
            top: 51.43%;
            left: 47.86%;
          }
          .pop {
            bottom: 48.57%;
            left: 48.72%;
            border-bottom-left-radius: 0;
            i {
              background-image: url(@/assets/img/dashboard/dot-icon-2.png);
            }
          }
        }
        .p-3 {
          .dot {
            top: 49.52%;
            left: 45.93%;
          }
          .pop {
            top: 52.08%;
            right: 53.23%;
            border-top-right-radius: 0;
            i {
              background-image: url(@/assets/img/dashboard/dot-icon-3.png);
            }
          }
        }
        .p-4 {
          .dot {
            top: 44.08%;
            left: 42.65%;
          }
          .pop {
            top: 46.44%;
            right: 56.84%;
            border-top-right-radius: 0;
            i {
              background-image: url(@/assets/img/dashboard/dot-icon-4.png);
            }
          }
        }
        .p-5 {
          .dot {
            top: 43.27%;
            left: 40.05%;
            border-color: #ff0000;
          }
          .pop {
            bottom: 56.6%;
            right: 59.11%;
            border-bottom-right-radius: 0;
            background-color: #ff0000;
            i {
              background-image: url(@/assets/img/dashboard/dot-icon-5.png);
            }
          }
        }
        .p-6 {
          .dot {
            top: 42.58%;
            left: 56.09%;
            border-color: #F37041;
          }
          .pop {
            bottom: 57.41%;
            left: 56.86%;
            border-bottom-left-radius: 0;
            background-color: #F37041;
            i {
              background-image: url(@/assets/img/dashboard/dot-icon-6.png);
            }
          }
        }
      }
       .p-exit{
            position: absolute;
            top: 0;
            left: 0;
            z-index: 3;
            width: 100%;
            height: 100%;
            overflow: hidden;
            color: #fff;
            > div {
                .dot {
                    position: absolute;
                    width: 1.679261%;
                    height: 2.721088%;
                    border: 3px solid #0a7bfd;
                    border-radius: 50%;
                    background: #fff;
                }
                .pop {
                    position: absolute;
                    height: 40px;
                    padding: 2px;
                    border-radius: 20px;
                    background-color: #0a7bfd;
                    cursor: pointer;
                    animation: bounceIn 0.75s ease 0.5s;
                    i {
                        display: inline-block;
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        background-color: #fff;
                        background-repeat: no-repeat;
                        background-position: center;
                    }
                    span {
                        display: inline-block;
                        padding: 0 10px 0 4px;
                        line-height: 34px;
                        vertical-align: top;
                        b {
                            padding: 0 4px;
                            font-size: 22px;
                            font-weight: 500;
                        }
                    }
                }
            }   
            .p-1 {
                .dot {
                    top: 43.27%;
                    left: 40.05%;
                    border-color: #0ab0a6;
                }
                .pop {
                    top: 38%;
                    right: 59.11%;
                    border-bottom-right-radius: 0;
                    background-color: #0ab0a6;
                    i {
                        background-image: url(@/assets/img/dashboard/dot-icon-1.png);
                    }
                }
            }
            .p-3 {
                .dot {
                    top: 49.52%;
                    left: 45.93%;
                }
                .pop {
                    top: 52.08%;
                    right: 53.23%;
                    border-top-right-radius: 0;
                    i {
                        background-image: url(@/assets/img/dashboard/dot-icon-3.png);
                    }
                }
            }
        
            .p-5 {
                .dot {
                    top: 8.75%;
                    left: 95.97%;
                    border-color: #ff0000;
                }
                .pop {
                    top: 11.56%;
                    right: 3.11%;
                    border-top-right-radius: 0;
                    background-color: #ff0000;
                    i {
                        background-image: url(@/assets/img/dashboard/dot-icon-5.png);
                    }
                }
            }
        
        }

      .todo-wrap {
        position: absolute;
        left: 16.46%;
        bottom: 6.94%;
        z-index: 4;
        width: 67.17%;
        height: 27.21%;
        border-radius: 16px;
        background: #fff;
        > div {
          position: relative;
          float: left;
          width: 50%;
          height: 100%;
          .title {
            position: absolute;
            top: 8%;
            left: 5%;
            font-size: 16px;
            line-height: 16px;
            color: #000;
          }
          .chart {
            width: 100%;
            height: 100%;
            canvas {
              // cursor: default;
            }
          }
        }
        .my-todo {
          border-right: 1px solid #e5e5e5;
        }
      }
    }
  }
}

.el-popover.el-popper.stats-progress-pop {
  padding: 0;
  border: none;
  box-shadow: none;
  background: none;
  .el-popper__arrow {
    display: none;
  }
}

@media screen and (max-width: 1440px) {
  .dashboard {
    .stats-container .map-wrap {
      .place {
        font-size: 12px;
        > div {
          .pop {
            height: 30px;
            border-radius: 15px;
            i {
              width: 26px;
              height: 26px;
            }
            span {
              line-height: 24px;
              b {
                font-size: 16px;
              }
            }
          }
        }
      }
      .todo-wrap {
        left: 5%;
        width: 90%;
        > div .title {
          font-size: 14px;
          line-height: 14px;
        }
      }
    }
  }
}
</style>
